import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { demoCenterPath, demoDomainHref, demoDomains } from '../../data/demoCenter';
import { fadeUp } from '../../utils/motion';
import { DomainIcon } from '../demoCenter/DomainIcon';
export function HomeDemoCenter() {
  return <section aria-labelledby="home-demo-title" className="bg-white border-b border-line py-20 lg:py-24" data-id="element-466" data-mp="1y4sa6zzc7att">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-467" data-mp="10j4cmbr5amgp">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 items-end mb-10" data-id="element-468" data-mp="15gwfg0tbvszo">
          <div className="lg:col-span-7" data-id="element-469" data-mp="1afph8vz95vk0">
            <p className="text-sm font-medium text-teal mb-3" data-id="element-470" data-mp="1aeo3ukurkwz4">Noetivra Demo Center</p>
            <h2 id="home-demo-title" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-471" data-mp="1f7r236ahkuln">
              See the architecture in action.
            </h2>
            <p className="mt-5 text-lg text-ink-muted leading-relaxed max-w-2xl" data-id="element-472" data-mp="mobr8wokqc27">
              Explore Noetivra’s domain-specific workspaces, beginning with the working Government and National
              Capability and Development System demonstration.
            </p>
          </div>
          <div className="lg:col-span-5 lg:text-right" data-id="element-473" data-mp="zaj4gz742bll">
            <a href={demoCenterPath} className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-474" data-mp="uchoin4zesec">
              Explore Noetivra Demos
              <ArrowRight size={18} aria-hidden="true" data-id="element-475" data-mp="geszr47sn140" />
            </a>
          </div>
        </motion.div>

        <motion.ul {...fadeUp} aria-label="Demo Center domains" className="flex flex-wrap gap-3" data-id="element-476" data-mp="bfyjoa17nqnl">
          {demoDomains.map(domain => <li key={domain.id} data-id="element-477" data-mp="2apeu1g7apxgx">
              <a href={demoDomainHref(domain.id)} className="inline-flex items-center gap-3 rounded-lg border border-line bg-white py-2 pl-2 pr-4 hover:border-navy-light hover:bg-surface-bg transition-colors duration-150" data-id="element-478" data-mp="25sg130zdbwkb">
                <DomainIcon id={domain.id} data-id="element-479" data-mp="3qaqlsy0ihuo4" />
                <span className="text-sm font-semibold text-ink-dark whitespace-nowrap" data-id="element-480" data-mp="3qc1nmsaecscl">{domain.title}</span>
                {domain.status === 'interactive' && <span className="text-xs font-semibold text-navy whitespace-nowrap" data-id="element-481" data-mp="mu9rd1p89m8l">· Interactive demo</span>}
              </a>
            </li>)}
        </motion.ul>
      </div>
    </section>;
}